// PakNet Urdu strings (frontend). Admin area uses English.
// Terminology chosen to match natural Urdu forum vocabulary:
//   thread → موضوع (topic) — more natural than the anglicism "دھاگا"
//   posts  → پیغامات
//   views  → مشاہدات (observations/views) — accurate; "آراء" means "opinions"
//   pinned → چسپاں (stuck/attached) — classic phpBB usage in Urdu boards
export const t = {
  brand: "PakNet",
  tagline: "پاکستان کا اردو فورم",
  home: "مرکزی صفحہ",
  forums: "فورمز",
  latestPosts: "تازہ پیغامات",
  members: "اراکین",
  login: "لاگ اِن",
  logout: "لاگ آؤٹ",
  register: "اکاؤنٹ بنائیں",
  username: "صارف کا نام",
  email: "ای میل",
  password: "پاس ورڈ",
  submit: "جمع کریں",
  search: "تلاش",
  searchPlaceholder: "موضوعات یا پیغامات ڈھونڈیں…",
  newThread: "نیا موضوع",
  reply: "جواب دیں",
  quote: "اقتباس",
  edit: "ترمیم",
  delete: "حذف",
  pin: "چسپاں کریں",
  unpin: "چسپاں ہٹائیں",
  lock: "مقفل کریں",
  unlock: "کھولیں",
  like: "پسند",
  liked: "پسند شدہ",
  loading: "لوڈ ہو رہا ہے…",
  threads: "موضوعات",
  replies: "جوابات",
  views: "مشاہدات",
  lastPost: "آخری پیغام",
  posts: "پیغامات",
  postedOn: "بتاریخ",
  joined: "شمولیت",
  postCount: "پیغامات",
  profile: "پروفائل",
  settings: "ترتیبات",
  admin: "ایڈمن",
  save: "محفوظ کریں",
  cancel: "منسوخ",
  title: "عنوان",
  content: "متن",
  postReply: "جواب پوسٹ کریں",
  createThread: "موضوع شروع کریں",
  locked: "مقفل",
  pinned: "چسپاں",
  by: "بذریعہ",
  admin_role: "ایڈمن",
  mod_role: "معاون",
  user_role: "رکن",
  banned: "معطل",
  bio: "تعارف",
  signature: "دستخط",
  avatar: "آواتار (تصویر کا لنک)",
  saveProfile: "پروفائل محفوظ کریں",
  noThreads: "ابھی تک کوئی موضوع نہیں۔ پہلا موضوع آپ شروع کریں!",
  noPosts: "کوئی پیغام نہیں ملا۔",
  loginRequired: "جواب دینے کے لیے لاگ اِن کریں",
  welcome: "PakNet میں خوش آمدید",
  heroSub:
    "پاکستانی برادری کا اردو ڈسکشن فورم — کھل کر گفتگو کیجیے، سیکھیے اور دوست بنائیے۔",
  joinNow: "ابھی شامل ہوں",
  browseForums: "فورمز دیکھیں",
  totalThreads: "کل موضوعات",
  totalPosts: "کل پیغامات",
  totalMembers: "اراکین",
  newest: "نیا رکن",
  page: "صفحہ",
  of: "از",
  bold: "بولڈ",
  italic: "ترچھا",
  linkText: "لنک",
  image: "تصویر",
  gif: "GIF/سٹیکر",
  list: "فہرست",
  code: "کوڈ",
  removeQuote: "اقتباس ہٹائیں",
  imageUrlPrompt: "تصویر کا URL درج کریں:",
  linkUrlPrompt: "لنک کا URL درج کریں:",
  linkTextPrompt: "لنک کا متن درج کریں:",
  yourReply: "اپنا جواب یہاں لکھیے…",
  yourPost: "اپنا پیغام یہاں لکھیے…",
  moderation: "نگرانی",
  reallyDelete: "کیا واقعی حذف کرنا چاہتے ہیں؟",
  yes: "جی ہاں",
  no: "نہیں",
  category: "زمرہ",
  none: "کچھ نہیں",
  subForums: "ذیلی فورمز",
  trending: "زیرِ بحث",
  trendingSub: "جن موضوعات پر سب سے زیادہ گفتگو ہو رہی ہے",
  recentActivity: "تازہ سرگرمی",
  activityLabel: "ابھی چل رہا ہے",
  viewAll: "سب دیکھیں",
  parentForum: "بنیادی فورم",
};
